import * as types from './types';
import {ANALYTICS_EVENT} from '../../actions/analytics/types'

export const analyticsCartBuy = (cart) => ({
  type: types.ANALYTICS_EVENT,
  payload: {
    hitType: 'event',
    eventCategory: 'Cart',
    eventAction: 'buy',
    eventLabel: cart.price,
  },
});

export const analyticsNewSessionRequest = () => ({
  type: types.ANALYTICS_NEW_SESSION.REQUEST,
  payload: {},
});

export const analyticsViewTicketRequest = (ticket, quantity) => ({
  type: types.ANALYTICS_VIEW_TICKET.REQUEST,
  payload: {
    ticket,
    quantity,
  },
});

export const analyticsBuyTicketRequest = (ticket, quantity) => ({
  type: types.ANALYTICS_BUY_TICKET.REQUEST,
  payload: {
    ticket,
    quantity,
  },
});

export const analyticsRecordActionRequest = (actiontype, action, actiondata) => ({
  type: types.ANALYTICS_ACTION.REQUEST,
  payload: {
    action,
    actiondata,
    actiontype,
  },
  meta: {
    analytics: {
      type: ANALYTICS_EVENT,
      payload: {
        hitType: 'event',
        eventCategory: actiontype,
        eventAction: action,
        eventLabel: actiondata,
      },
    },
  },
});



// WEBPACK FOOTER //
// ./src/actions/analytics/actions.js